import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API } from 'src/app/core/constants/api';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class SimulationResultsDownloadService {
  constructor(private httpClient: HttpClient, private authService: AuthService) {}

  downloadResults(simulationId: string): Observable<any> {
    const newId = `${this.authService.getCurrentUser()?.username}-${simulationId}`;
    return this.httpClient.get(`${API.SIMULATION_RESULT_DOWNLOAD}?key=${newId}`, {
      responseType: 'blob',
    });
  }

  downloadResultsFromSimSub(anflexWebId: string): Observable<any> {
    return this.httpClient.get(
      `${API.SIMULATION_RESULT_DOWNLOAD}/anflex_web_download_files/${anflexWebId}`,
      {
        responseType: 'arraybuffer',
      },
    );
  }
}
